import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Button, Flex, Text } from "@paguelofacil/pf-components";
import { toast } from "react-toastify";

import { language, languageDefault } from "../services/utils/Language";
import { STEPS } from "../services/utils/Constants";
import { fullnameSpaces } from "../services/utils/Validations";
import { useLoginCryptofacil } from "../hooks/useLogin";
import { useSignup } from "../hooks/useSignup";

import { InputTextEmail } from "./Inputs/Email";
import { PhoneInput } from "./Inputs/Phone";
import { InputText } from "./Inputs/Text";

const SignupForm = ({ intl, handleChangeForm, valuesForm, setStep, setIsLoading }) => {
    const navigate = useNavigate();
    const { createAccount, isLoading: isLoginSignUp } = useSignup();
    const { isLoadingLogin, loginAccountCryptofacil } = useLoginCryptofacil();

    const handleSubmit = async event => {
        try {
            setIsLoading(true);
            event.preventDefault();

            console.log("valuesForm para crear cuenta", valuesForm);
            const responseCreateAccount = await createAccount(valuesForm);
            console.log("responseCreateAccount handleSubmit", responseCreateAccount);

            if (!responseCreateAccount) {
                return;
            }

            const loginResponse = await loginAccountCryptofacil(valuesForm.email);
            console.log("loginResponse handleSubmit", loginResponse);

            if (!loginResponse) {
                return;
            }

            setStep(STEPS.VALIDATE_CODE);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const shouldDisabledButtonNext = !valuesForm.name || !valuesForm.email;

    const placeholderPhone = intl.formatMessage({
        id: language.enter_number,
        defaultMessage: languageDefault.enter_number,
    });

    const placeholderName = intl.formatMessage({
        id: language.enter_full_name,
        defaultMessage: languageDefault.enter_full_name,
    });

    useEffect(() => {
        setIsLoading(isLoginSignUp || isLoadingLogin);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoginSignUp, isLoadingLogin]);

    return (
        <form style={{ width: "100%" }} onSubmit={handleSubmit}>
            <Flex gap="1.25rem" direction="column">
                <InputText
                    label={<FormattedMessage id={language.full_name} defaultMessage={languageDefault.full_name} />}
                    name="name"
                    placeholder={placeholderName}
                    onChangeValue={value => handleChangeForm("name", value)}
                    validation={fullnameSpaces}
                    isRequired={true}
                />
                <InputTextEmail
                    label={<FormattedMessage id={language.email} defaultMessage={languageDefault.email} />}
                    name="email"
                    placeholder="correo.user@mail.com"
                    onChangeValue={value => handleChangeForm("email", value)}
                    isRequired={true}
                />
                <PhoneInput
                    label={<FormattedMessage id={language.phone} defaultMessage={languageDefault.phone} />}
                    onChange={value => handleChangeForm("phone", value)}
                    country="PA"
                    placeholder={placeholderPhone}
                />
                <Button
                    className="button-primary-cf"
                    fullWidth
                    size="md"
                    type="submit"
                    style={{ marginTop: "1.25rem" }}
                    disabled={shouldDisabledButtonNext}
                >
                    <FormattedMessage id={language.create_account} defaultMessage={languageDefault.create_account} />
                </Button>
                <Text
                    variant="caption"
                    weight="regular"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <FormattedMessage
                        id={language.do_you_has_account}
                        defaultMessage={languageDefault.do_you_has_account}
                    />
                    &nbsp;
                    <Button
                        variant="link"
                        handleClick={() => navigate("/cryptofacil/login")}
                        style={{ color: "#378FA2" }}
                    >
                        <FormattedMessage id={language.enter} defaultMessage={languageDefault.enter} />
                    </Button>
                </Text>
            </Flex>
        </form>
    );
};

export default SignupForm;
